"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExploreGroupedTransactionsPaginatedListSchema = exports.ExploreGroupedTransactionSchema = exports.ExploreTransactionsPaginatedListSchema = exports.ExploreTransactionSchema = exports.ExploreTransactionTypeEnum = void 0;
const core_contracts_ifaces_1 = require("@tutellus/core-contracts-ifaces");
const zod_1 = require("zod");
var ExploreTransactionTypeEnum;
(function (ExploreTransactionTypeEnum) {
    ExploreTransactionTypeEnum["SWAP"] = "SWAP";
    ExploreTransactionTypeEnum["ADD"] = "ADD";
    ExploreTransactionTypeEnum["REMOVE"] = "REMOVE";
})(ExploreTransactionTypeEnum || (exports.ExploreTransactionTypeEnum = ExploreTransactionTypeEnum = {}));
// Explore Transactions
exports.ExploreTransactionSchema = zod_1.z.object({
    id: zod_1.z.string(),
    date: zod_1.z.string().datetime(), // ISO 8601
    type: zod_1.z.nativeEnum(ExploreTransactionTypeEnum),
    token0: core_contracts_ifaces_1.TokenAmountSchema,
    token1: core_contracts_ifaces_1.TokenAmountSchema,
    poolID: zod_1.z.string(),
    totalAmount: zod_1.z.array(core_contracts_ifaces_1.CurrencyAmountSchema),
    sender: zod_1.z.string(),
    txHash: zod_1.z.string(),
    logIndex: zod_1.z.number(),
    txIndex: zod_1.z.number(),
    tokenIn: zod_1.z.string().optional().nullable(),
    tokenOut: zod_1.z.string().optional().nullable(),
    txInputRaw: zod_1.z.string().optional().nullable(),
});
exports.ExploreTransactionsPaginatedListSchema = zod_1.z.object({
    items: zod_1.z.array(exports.ExploreTransactionSchema),
    metadata: core_contracts_ifaces_1.PaginationMetadataSchema,
});
// Explore Transactions Grouped
exports.ExploreGroupedTransactionSchema = exports.ExploreTransactionSchema.merge(zod_1.z.object({
    txList: zod_1.z.array(exports.ExploreTransactionSchema),
}));
exports.ExploreGroupedTransactionsPaginatedListSchema = zod_1.z.object({
    items: zod_1.z.array(exports.ExploreTransactionSchema),
    metadata: core_contracts_ifaces_1.PaginationMetadataSchema,
});
